// Direct DOM manipulation approach for more reliable results
document.addEventListener('DOMContentLoaded', function() {
	// Find all kerktijden widgets
	const widgets = document.querySelectorAll('[data-wp-interactive="create-block/kerktijden"]');
	
	widgets.forEach(widget => {
		loadKerktijdenData(widget);
	});
});

async function loadKerktijdenData(widget) {
	try {
		// Get context data
		const contextData = JSON.parse(widget.getAttribute('data-wp-context') || '{}');
		const { communityId, weeks, maxItems } = contextData;
		
		// Show loading state
		const loadingEl = widget.querySelector('.kerktijden-loading');
		const contentEl = widget.querySelector('.kerktijden-services');
		const noDataEl = widget.querySelector('.kerktijden-no-data');
		
		// Reset any inline styles and use classes only
		if (contentEl) {
			contentEl.style.display = '';
			contentEl.classList.add('kerktijden-hidden');
		}
		if (noDataEl) {
			noDataEl.style.display = '';
			noDataEl.classList.add('kerktijden-hidden');
		}
		if (loadingEl) {
			loadingEl.style.display = '';
			loadingEl.classList.remove('kerktijden-hidden');
		}
		
		// Fetch data
		const url = `https://api.kerktijden.nl/api/gathering/GetGatheringsForWidget?communityId=${communityId}&weeks=${weeks}`;
		const response = await fetch(url);
		
		if (!response.ok) {
			throw new Error('Network response was not ok');
		}
		
		const data = await response.json();
		const gatherings = data.slice(0, maxItems);
		
		// Hide loading
		if (loadingEl) loadingEl.classList.add('kerktijden-hidden');
		
		if (gatherings.length > 0) {
			// Show content and render gatherings
			if (contentEl) {
				contentEl.classList.remove('kerktijden-hidden');
				renderGatherings(contentEl, gatherings);
			}
		} else {
			// Show no data message
			if (noDataEl) noDataEl.classList.remove('kerktijden-hidden');
		}
		
	} catch (error) {
		console.error('Error fetching gatherings:', error);
		
		// Hide loading and show no data
		const loadingEl = widget.querySelector('.kerktijden-loading');
		const noDataEl = widget.querySelector('.kerktijden-no-data');
		
		if (loadingEl) {
			loadingEl.style.display = '';
			loadingEl.classList.add('kerktijden-hidden');
		}
		if (noDataEl) {
			noDataEl.style.display = '';
			noDataEl.classList.remove('kerktijden-hidden');
		}
	}
}

function renderGatherings(container, gatherings) {
	container.innerHTML = '';
	
	gatherings.forEach(gathering => {
		const item = document.createElement('div');
		item.className = 'kerktijden-item';
		
		const formattedDate = formatDate(gathering.startTime);
		const formattedTime = formatTime(gathering.startTime);
		const serviceType = getServiceType(gathering);
		const preacherHtml = getPreacherHtml(gathering);
		
		item.innerHTML = `
			<div class="kerktijden-date-time">
				<div class="kerktijden-date">
					<span class="date-icon">📅</span>
					<span>${formattedDate}</span>
				</div>
				<div class="kerktijden-time">
					<span class="time-icon">🕐</span>
					<span>${formattedTime}</span>
				</div>
			</div>
			<div class="kerktijden-content">
				<h4 class="kerktijden-service-type">${serviceType}</h4>
				<div class="kerktijden-preacher">Voorganger: ${preacherHtml}</div>
			</div>
		`;
		
		container.appendChild(item);
	});
}

// Helper functions from the original widget
function formatDate(dateString) {
	const date = new Date(dateString);
	const days = ["Zondag", "Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrijdag", "Zaterdag"];
	const months = ["jan", "feb", "mrt", "apr", "mei", "jun", "jul", "aug", "sep", "okt", "nov", "dec"];
	return `${days[date.getDay()]} ${date.getDate()} ${months[date.getMonth()]}`;
}

function formatTime(dateString) {
	const value = dateString + "Z"; // interpret as UTC
	const tz = (new Date(value)).getTimezoneOffset();
	const date = new Date(new Date(value).getTime() + (60000 * tz));
	const hours = (date.getHours() + 100).toString().substr(1, 2);
	const minutes = (date.getMinutes() + 100).toString().substr(1, 2);
	return `${hours}:${minutes} uur`;
}

function getServiceType(gathering) {
	if (!gathering.gatheringTypes || gathering.gatheringTypes.length === 0) {
		return "Dienst";
	}
	let name = gathering.gatheringTypes[0].name;
	return name.charAt(0).toUpperCase() + name.slice(1);
}

function getPreacherName(gathering) {
	if (!gathering.persons || gathering.persons.length === 0) {
		return "geen voorganger";
	}
	const person = gathering.persons[0];
	const status = person.status ? person.status.statusShort : "";
	const insertion = person.insertion || "";
	return `${status} ${person.initials} ${insertion} ${person.lastname}`.trim().replace(/\s+/g, ' ');
}

function getPreacherHtml(gathering) {
	if (!gathering.persons || gathering.persons.length === 0) {
		return "geen voorganger";
	}
	
	const person = gathering.persons[0];
	const status = person.status ? person.status.statusShort : "";
	const insertion = person.insertion || "";
	const name = `${status} ${person.initials} ${insertion} ${person.lastname}`.trim().replace(/\s+/g, ' ');
	
	// Create link like the original widget
	if (person.id === 1) {
		return name;
	} else {
		const slug = slugify(name);
		const link = `https://www.kerktijden.nl/voorganger/${person.id}/${slug}`;
		return `<a target="_blank" href="${link}">${name}</a>`;
	}
}

function slugify(text) {
	let str = text.replace(/^\s+|\s+$/g, ""); // trim
	str = str.toLowerCase();
	
	// remove accents, swap ñ for n, etc
	const from = "åàáãäâèéëêìíïîòóöôùúüûñç·/_,:;";
	const to = "aaaaaaeeeeiiiioooouuuunc------";
	for (let i = 0, l = from.length; i < l; i++) {
		str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
	}
	
	str = str
		.replace(/[^a-z0-9 -]/g, "") // remove invalid chars
		.replace(/\s+/g, "-") // collapse whitespace and replace by -
		.replace(/-+/g, "-") // collapse dashes
		.replace(/^-+/, "") // trim - from start of text
		.replace(/-+$/, ""); // trim - from end of text
	
	return str;
}
